import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-room',
  templateUrl: './manage-room.component.html',
  styleUrls: ['./manage-room.component.scss']
})
export class ManageRoomComponent implements OnInit {
  
  isChecked:boolean = true;
  showCaseDetail: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  openCaseDetail(){
    this.showCaseDetail = true;
  }
 
  getCloseCaseDetail(message){
    this.showCaseDetail = message;
  }

}
